import React from 'react'

export default function NavItem({ page, label, setIsOpen, setCurrentPage, textConfig }) {
    if (!textConfig) {
        textConfig = '';
    }

    const handleClick = (page) => {
        setIsOpen(false);
        setCurrentPage(page);
    }

    return (
        <button
            key={page}
            onClick={() => handleClick(page)}
            className={`${textConfig} text-orange-400 hover:scale-110 text-nowrap`}
        >
            {label}
        </button>
    )
}

